var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtengagementimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7576_49759)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7576_49759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5379 5.70678C20.4323 5.28492 20.2172 4.8984 19.9144 4.58625C19.6116 4.2741 19.2319 4.04738 18.8133 3.929C17.2845 3.55566 11.1689 3.55566 11.1689 3.55566C11.1689 3.55566 5.05336 3.55566 3.52447 3.96456C3.10601 4.08294 2.72623 4.30966 2.42344 4.62181C2.12065 4.93396 1.90561 5.32048 1.80002 5.74233C1.52021 7.29394 1.38334 8.86794 1.39113 10.4446C1.38116 12.033 1.51804 13.619 1.80002 15.1823C1.91643 15.5911 2.13629 15.9629 2.43837 16.2618C2.74045 16.5609 3.11453 16.7769 3.52447 16.889C5.05336 17.2979 11.1689 17.2979 11.1689 17.2979C11.1689 17.2979 17.2845 17.2979 18.8133 16.889C19.2319 16.7706 19.6116 16.5439 19.9144 16.2318C20.2172 15.9195 20.4323 15.5331 20.5379 15.1113C20.8155 13.5713 20.9523 12.0093 20.9467 10.4446C20.9567 8.85608 20.8197 7.27006 20.5379 5.70678Z",
    stroke: "#F61C0D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 13.3514L14.2751 10.4448L9.16406 7.53809V13.3514Z",
    stroke: "#F61C0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7576_49759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7576_49759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtengagementimg);
export default __webpack_public_path__ + "static/media/yt engagement img.5a92167577458d2202cf6fdb289e85b0.svg";
export { ForwardRef as ReactComponent };